import React, { useEffect } from "react";
import BookingCard from "./BookingCard";
import car1 from "../../assets/assets/images/home_images/home_grid4.png";
import car2 from "../../assets/assets/images/home_images/tag_car.png";
import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { MdDoubleArrow } from "react-icons/md";
import { TiArrowSortedDown } from "react-icons/ti";
import CompletedOrder from "./CompletedOrder";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserBooking } from "../../redux/Slice/bookingSlice";
import { getUserDetail } from "../../redux/Slice/authSlice";

const Index = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loginDetail = useSelector((state) => state?.auth?.loginId);
  const userDetail = useSelector((state) => state?.auth?.userDetail);
  useEffect(() => {
    dispatch(getUserDetail(userDetail?.data?._id));
    if (!loginDetail) {
      navigate("/login");
    }
    dispatch(fetchUserBooking({ userId: userDetail?.data?._id }));
  }, []);

  return (
    <div className="m-auto max_container pb-6">
      <div className=" px-0">
        <div className="d-flex flex-row fs-1 accentColor align-items-center my-3 ps-3 ps-lg-5">
          <span className="lh-0">
            <MdDoubleArrow />
          </span>
          <span className="font ">Booking History</span>
        </div>
        {/* <h2 className='font accentColor my-3 ps-3' ><MdDoubleArrow />Booking History</h2> */}
        <ul className="booking-heading px-0 d-flex flex-row gap-3 px-3 justify-content-evenly">
          <li>
            <NavLink
              to="/mybooking/recent-order"
              className="primaryColor fs18 mobile-font14"
            >
              Upcoming
              <TiArrowSortedDown />
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/mybooking/completed-order"
              className="primaryColor fs18 mobile-font14"
            >
              Completed <TiArrowSortedDown />
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/mybooking/cancelled-order"
              className="primaryColor fs18 mobile-font14"
            >
              Cancelled <TiArrowSortedDown />
            </NavLink>
          </li>
        </ul>
        {/* <div> */}
        <Outlet />
        {/* </div> */}
      </div>
    </div>
  );
};

export default Index;
